import { MouseEventHandler } from 'react';
import LinkButton from '../button/LinkButton';

export type CellProps = {
  placeholder: string;
  value: string;
  onClick?: MouseEventHandler;
  className?: string;
  phoneNumber?: string;
  googleMapAddress?: string;
};

function Cell({ placeholder, value, className, phoneNumber, googleMapAddress }: CellProps) {
  const shouldRenderLinkButton = phoneNumber || googleMapAddress;

  return (
    <li key={placeholder} className={`px-4 py-3 ${className ?? ''}`}>
      <p className="text-sm text-gray-500">{placeholder}</p>
      {shouldRenderLinkButton ? (
        <LinkButton
          title={value}
          {...(phoneNumber && { phoneNumber: value })}
          {...(googleMapAddress && { googleMapAddress: value })}
        />
      ) : (
        <p className="text-base font-medium text-gray-900">{value}</p>
      )}
    </li>
  );
}

export default Cell;
